const { createAction } = require('../helpers')
const {
  GET_SHORTURL_LIST,
  GET_SHORTURL_LIST_SUCCESS,
  GET_SHORTURL_LIST_ERROR,
  GET_SHORTURL_LIST_RESET,

  GET_SHORTURL,
  GET_SHORTURL_SUCCESS,
  GET_SHORTURL_ERROR,
  GET_SHORTURL_RESET,

  CREATE_SHORTURL,
  CREATE_SHORTURL_SUCCESS,
  CREATE_SHORTURL_ERROR,
  CREATE_SHORTURL_RESET,

  UPDATE_SHORTURL,
  UPDATE_SHORTURL_SUCCESS,
  UPDATE_SHORTURL_ERROR,
  UPDATE_SHORTURL_RESET,

  DELETE_SHORTURL,
  DELETE_SHORTURL_SUCCESS,
  DELETE_SHORTURL_ERROR,
  DELETE_SHORTURL_RESET,
} = require('./constants')

// eslint-disable-next-line max-len
const getShorturlList = ({ take, skip }) => createAction(GET_SHORTURL_LIST, { take, skip })
const getShorturlListSuccess = data => createAction(GET_SHORTURL_LIST_SUCCESS, { data })
const getShorturlListError = error => createAction(GET_SHORTURL_LIST_ERROR, { error })
const getShorturlListReset = () => createAction(GET_SHORTURL_LIST_RESET)

const getShorturl = id => createAction(GET_SHORTURL, { id })
const getShorturlSuccess = data => createAction(GET_SHORTURL_SUCCESS, { data })
const getShorturlError = error => createAction(GET_SHORTURL_ERROR, { error })
const getShorturlReset = () => createAction(GET_SHORTURL_RESET)

const createShorturl = shorturlData => createAction(CREATE_SHORTURL, { shorturlData })
const createShorturlSuccess = data => createAction(CREATE_SHORTURL_SUCCESS, { data })
const createShorturlError = error => createAction(CREATE_SHORTURL_ERROR, { error })
const createShorturlReset = () => createAction(CREATE_SHORTURL_RESET)

const updateShorturl = ({ id, shorturlData }) => createAction(UPDATE_SHORTURL, { id, shorturlData })
const updateShorturlSuccess = data => createAction(UPDATE_SHORTURL_SUCCESS, { data })
const updateShorturlError = error => createAction(UPDATE_SHORTURL_ERROR, { error })
const updateShorturlReset = () => createAction(UPDATE_SHORTURL_RESET)

const deleteShorturl = ({ id }) => createAction(DELETE_SHORTURL, { id })
const deleteShorturlSuccess = data => createAction(DELETE_SHORTURL_SUCCESS, { data })
const deleteShorturlError = error => createAction(DELETE_SHORTURL_ERROR, { error })
const deleteShorturlReset = () => createAction(DELETE_SHORTURL_RESET)

module.exports = {
  getShorturlList,
  getShorturlListSuccess,
  getShorturlListError,
  getShorturlListReset,
  getShorturl,
  getShorturlSuccess,
  getShorturlError,
  getShorturlReset,
  createShorturl,
  createShorturlSuccess,
  createShorturlError,
  createShorturlReset,
  updateShorturl,
  updateShorturlSuccess,
  updateShorturlError,
  updateShorturlReset,
  deleteShorturl,
  deleteShorturlSuccess,
  deleteShorturlError,
  deleteShorturlReset,
}
